import React from "react";

import Radio from "antd/es/radio";
import { useIntl } from "react-intl";

import { EntityType } from "@mapmycustomers/shared/enum";

import RadioGroup from "@app/component/input/RadioGroup";

import styles from "./EntityTypeSelector.module.scss";

interface Props {
  onChange: (include: boolean) => void;
  relatedEntityType: EntityType.COMPANY | EntityType.PERSON;
  value: boolean;
}

const IncludeDealsSelector: React.FC<Props> = ({ onChange, relatedEntityType, value }) => {
  const intl = useIntl();

  return (
    <div className={styles.container}>
      <div>
        {relatedEntityType === EntityType.COMPANY
          ? intl.formatMessage({
              id: "view.selectBar.addRemove.includeDealsSelector.byCompany",
              defaultMessage: "Include Deals associated with Companies?",
              description: "Bulk edit panel - Include Deals associated with Companies",
            })
          : intl.formatMessage({
              id: "view.selectBar.addRemove.includeDealsSelector.byPerson",
              defaultMessage: "Include Deals associated with People?",
              description: "Bulk edit panel - Include Deals associated with People",
            })}
      </div>
      <RadioGroup onChange={onChange} value={value}>
        <Radio.Button value={true}>
          {intl.formatMessage({
            id: "view.selectBar.addRemove.includeDealsSelector.yes",
            defaultMessage: "Yes, include Deals",
            description: "Bulk edit panel - Include Deals associated with People - yes",
          })}
        </Radio.Button>
        <Radio.Button value={false}>
          {intl.formatMessage({
            id: "view.selectBar.addRemove.includeDealsSelector.no",
            defaultMessage: "No, exclude Deals",
            description: "Bulk edit panel - Include Deals associated with People - no",
          })}
        </Radio.Button>
      </RadioGroup>
    </div>
  );
};

export default IncludeDealsSelector;
